import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { emailValidator, passwordValidator } from '../../../shared/validators/common.validators';
import { Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../service/notification.service';
import { AuthService } from '../../service/auth-service';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TextInputComponent } from '../../../shared/components/text-input/text-input.component';
import { SelectComponent } from '../../../shared/components/select/select.component';
import {MatSelectModule} from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { phoneValidator } from '../../../shared/validators/phone-validator';

@Component({
  selector: 'app-service-provider-signup',
  imports: [TextInputComponent, CommonModule, FormsModule, ReactiveFormsModule,
    SelectComponent, RouterModule, MatSelectModule, MatDatepickerModule,
    MatNativeDateModule, MatInputModule],
  templateUrl: './service-provider-signup.component.html',
  styleUrl: './service-provider-signup.component.css'
})
export class ServiceProviderSignupComponent {
  signUpForm!: FormGroup;
  isPasswordVisible = false;
  loading:boolean = false;
  expertiseOptions:string[] = ['Property Management', 'Nurse Services', 'Elderly care', 'House Keeping', 'Government Documents',
    'Visa & Immigration Services', 'Travel Companion', 'Event Management']
  experienceLevelOptions:string[] = ['Below 5 Years', 'Above 5 Years']
  availabilityOptions:string[] = ['Full-Time', 'Part-Time', 'On-call']
  hearOptions:string[] = ['Social Media', 'Website', 'Referred by Friend', 'NRI Service Desk Member Referral']
  timeOptions:string[] = ['AM', 'PM']


    constructor(private formBuilder: FormBuilder, private router: Router,
    private authService: AuthService, private toastr: NotificationService,
    private dialog: MatDialog, private renderer: Renderer2,
     @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.signUpForm = this.formBuilder.group({
      firstName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      lastName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      mobileNumber: new FormControl('', phoneValidator()),
      email: new FormControl('', emailValidator),
      city: new FormControl('', [Validators.required]),
      business_name: new FormControl('',  [Validators.required]),
      expertise: this.formBuilder.control([], Validators.required),
      sub_service: new FormControl('', []),
      experience: new FormControl('',  [Validators.required]),
      availability: new FormControl('',  [Validators.required]),
      hear_about: new FormControl('', []),
      verify_date: new FormControl<Date | null>(null, []),
      preferred_time: new FormControl('', []),
      changePeriod: new FormControl('', []),
      password: new FormControl('', passwordValidator),
      confirmPassword: new FormControl('', [Validators.required]),
    });

    this.passwordMismatch = false;

  }


  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.addClass(document.body, 'nri-signup-body');
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.removeClass(document.body, 'nri-signup-body');
    }
  }

  get verifyDateControl() {
  return this.signUpForm.get('verify_date') as FormControl;
}

togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

getControl(fieldName: string): FormControl {
    return (this.signUpForm.get(fieldName) as FormControl) || new FormControl();
}

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }

  passwordMismatch: boolean = false;

   signUp() {
  this.markFormGroupTouched(this.signUpForm);
  this.passwordMismatch = false;

  if (this.signUpForm.valid) {
    if (
      this.signUpForm.value.password !== this.signUpForm.value.confirmPassword
    ) {
      this.passwordMismatch = true;
      return;
    }

    this.loading = true;

     const rawTime = this.signUpForm.value.preferred_time; // e.g. "07:48"
    const period = this.signUpForm.value.changePeriod;    // "AM"/"PM"
    const [hourStr, minute] = rawTime.split(':');
    let hour = +hourStr;

    // Convert to 24-hour for consistency
    if (period === 'PM' && hour < 12) {
      hour += 12;
    } else if (period === 'AM' && hour === 12) {
      hour = 0;
    }

    const formatted24hTime = `${hour.toString().padStart(2, '0')}:${minute}:00`;
    const finalPreferredTime = `${formatted24hTime} ${period}`; // e.g. "18:53:00 AM"

    // --- Format verify_date (YYYY-MM-DD) ---
    const today = new Date();
    const verifyDate = today.toISOString().split('T')[0]; // "2025-09-01"

    // --- Ensure expertise is stringified array ---
    const expertiseValue = this.signUpForm.value.expertise;
   const stringifiedExpertise = JSON.stringify(this.signUpForm.value.expertise).replace(/"/g, "'");

    // --- Final payload ---
    const payload = {
      data: {
        firstName: this.signUpForm.value.firstName,
        lastName: this.signUpForm.value.lastName,
        mobileNumber: this.signUpForm.value.mobileNumber,
        email: this.signUpForm.value.email,
        password: this.signUpForm.value.password,
        city: this.signUpForm.value.city,
        business_name: this.signUpForm.value.business_name,
        expertise: stringifiedExpertise,
        experience: this.signUpForm.value.experience,
        availability: this.signUpForm.value.availability,
        hear_about: this.signUpForm.value.hear_about,
        verify_date: verifyDate,
        preferred_time: finalPreferredTime,
        userType: 'Service Provider',
      }
    };


    this.authService.serviceProviderSignUp(payload).subscribe({
      next: (res) => {
        if (res) {
          this.toastr.success({
            message:
              'Registration successful! Please check your email to verify your account.',
          });
          this.router.navigate(['login']);
          this.loading = false;
        }
      },
      error: (error) => {
        this.loading = false;
        const message = [401, 403, 400, 500].includes(error.status)
          ? error?.error?.message
          : error.message;
        const errorMessage =
          message || 'Registration failed. Please try again.';
        this.toastr.error({ title: 'Error', message: errorMessage });
      },
      complete: () => {
      }
    });
  }
}

  onPasswordInput() {
    const password = this.signUpForm.get('password')?.value;
    const confirmPassword = this.signUpForm.get('confirmPassword')?.value;
    this.passwordMismatch = password && confirmPassword && password !== confirmPassword;
  }

  onExpertiseChange(value: any) {
  }
}
